import { UseFormReturn } from "react-hook-form";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";

export type ForgotPasswordFormData = {
  email: string;
};

export type Props = {
  /** Form instance from useForm */
  form: UseFormReturn<ForgotPasswordFormData>;
};

/**
 * Forgot password form component that renders email field.
 * This is a presentational component - business logic should be in the container.
 */
export function ForgotPasswordForm({ form }: Props) {
  return (
    <Form
      form={form}
      className="w-full"
      innerClassName="justify-center"
      errorContainerClassName="p-0 mt-8"
    >
      <FormField
        name="email"
        label="Email"
        component="Input"
        placeholder="Enter your email"
        autoComplete="username"
        required
      />
    </Form>
  );
}

export default ForgotPasswordForm;


